export const blogData = [
    {
        id: 1,
        title: 'Hello Reader, Hope you are keeping safe this is my first imagine story_',
        description: 'This is the toy that gives me a kiss and happens. I want to play in the garden. I never want to lose a smaller toy. I want to this is always with me never leave me alone.',
        date: 'Feb 27, 2022',
        image: '',
        url: 'hhttps://medium.com/@webdeveshverma/hello-reader-hope-you-are-keeping-safe-this-is-my-first-imagine-story-151333724c09'
    },
    {
        id: 2,
        title: 'Skills vs Degrees',
        description: 'Degree and skill are two sides of the same coin. To succeed in the race of life, a person needs to have a degree along with the skill.',
        date: 'Feb 27, 2022',
        image: '',
        url: 'hhttps://medium.com/@webdeveshverma/skills-vs-degrees-9f24c882f23b'
    },
    {
        id: 3,
        title: 'Clone of Nature Basket',
        description: 'Nature Basket is an Indian grocery delivery chain of retail stores focused in gourmet food.',
        date: 'Jun 17, 2022',
        image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgfccuuhv1Q_SLVTq8pi9-hk_cHsocWu2bOJZHyNwPvS5thovpZz98p6feLLtez3LRyTsvT11ZCGblTesnZqUXOdK_6_wmRfMD0yzlFbzYjZ6KXB0khsuEQEhz1z84RsGxHEgGAxmhueWL6N8sa2IkT-WfON_mJcPGOgMLT6gKXw-HLMnz8ZmTIVQAClw/s320/Screenshot%20(659).png',
        url: 'https://medium.com/@parmarambuldak800'
    },
   
   
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/